"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const colors = {
    /**
     * Color definition according to BAM Design System MASTER
     * https://www.figma.com/file/mufDXvaVfUjfsGa2li8pDg/B.A.M-Design-System-%2F-MASTER?node-id=917%3A3542&t=RYcsz3vPOrg7aPrr-0
     */
    Text: {
        Primary: {
            '100': '#2F435D',
            '80': '#59697D',
            '60': '#828E9E',
            '40': '#ACB4BE',
            '20': '#D5D9DF',
            Invers: '#FFFFFF',
        },
        Gray: {
            '30': '#FAFBFC',
            '50': '#F5F6F7',
            '80': '#F0F1F2',
        },
        Highlight: {
            Error: '#F1637E',
            Warning: '#FD8F0F',
            Success: '#02B8A8',
            Info: '#0904EF',
        },
    },
    Background: {
        Primary: {
            '100': '#02B8A8',
            '80': '#35C6B9',
            '60': '#67D4CB',
            '40': '#9AE3DC',
            '20': '#CCF1EE',
            Invers: '#FFFFFF',
        },
        Gray: {
            '30': '#FAFBFC',
            '50': '#F5F6F7',
            '80': '#F0F1F2',
            '100': '#EBEEF0',
        },
        Overlay: {
            Black_10: 'rgba(0, 0, 0, 0.1)',
            White_15: 'rgba(255, 255, 255, 0.15)',
            White_85: 'rgba(255, 255, 255, 0.85)',
        },
        Highlight: {
            Lighten1: {
                Error: "#EC9995",
                Warning: "#FACF85",
                Success: "#8FD4BD",
            },
            Lighten2: {
                Error: "#F7D6D5",
                Warning: "#FEF5E7",
                Success: "#D2EEE5",
            },
            Error: '#F1637E',
            Warning: "#F59E0B",
            Success: "#1EA97C",
        },
    },
    Border: {
        Primary: {
            '100': '#02B8A8',
            '80': '#35C6B9',
            '60': '#67D4CB',
            '40': '#9AE3DC',
            '20': '#CCF1EE',
            Invers: "#FFFFFF",
        },
        Highlight: {
            Warning: '#FD8F0F',
            Error: '#F1637E',
            Success: '#02B8A8',
            Info: '#0904EF',
        },
    },
    Button: {
        Primary: {
            '100': '#02B8A8',
            '80': '#35C6B9',
            '60': '#67D4CB',
            '40': '#9AE3DC',
            '20': '#CCF1EE',
        },
        Gray: {
            '50': '#F5F6F7',
            '80': '#EBECED',
        },
        Highlight: {
            Error: '#F1637E',
            Transparent: {
                Error: 'rgba(241, 99, 126, 0.2)',
            },
        },
    },
};
exports.default = colors;
//# sourceMappingURL=relic.js.map